import type { IconSvgObject } from './types';

const LanguageSquareIcon: IconSvgObject = [
  ["path", { d: "M7 8.5H11.5M11.5 8.5H17M11.5 8.5V7M8.5 17C11 15 14 11 14.5 8.5M10 11C10.5 12.5 12.5 15 13.5 15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LanguageSquareIcon;
